import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { t } from '../i18n';
const API = window.location.origin + '/api';
const OrderBook = () => {
  const token = localStorage.getItem('token');
  const dealer = JSON.parse(localStorage.getItem('dealer') || '{}');
  const headers = { Authorization: `Bearer ${token}` };
  const [offers, setOffers] = useState<any[]>([]);
  const [myOffers, setMyOffers] = useState<any[]>([]);
  const [selectedOffer, setSelectedOffer] = useState<any>(null);
  const [filterMetal, setFilterMetal] = useState('all');
  const [search, setSearch] = useState('');
  const [accepting, setAccepting] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [showCounter, setShowCounter] = useState(false);
  const [counterNote, setCounterNote] = useState('');
  const [counterCash, setCounterCash] = useState(0);
  const [counterCashDir, setCounterCashDir] = useState('request');
  const [counterLoading, setCounterLoading] = useState(false);
  useEffect(() => { fetchOffers(); axios.get(`${API}/offers/my`,{headers}).then(res=>setMyOffers(res.data.offers||[])); }, []);
  const fetchOffers = () => { axios.get(`${API}/offers`,{headers}).then(res=>setOffers(res.data.offers||[])); };
  const handleCounter = async () => {
    if (!selectedOffer) return;
    setCounterLoading(true);
    try {
      const cash = counterCashDir === 'request' ? counterCash : -counterCash;
      await axios.post(`${API}/counters/${selectedOffer.id}`, {
        have_product_id: selectedOffer.want_items?.[0]?.product_id || selectedOffer.want_product_id,
        want_product_id: selectedOffer.have_items?.[0]?.product_id || selectedOffer.have_product_id,
        have_quantity: selectedOffer.want_items?.[0]?.quantity || selectedOffer.want_quantity,
        want_quantity: selectedOffer.have_items?.[0]?.quantity || selectedOffer.have_quantity,
        cash_adjustment: cash,
        note: counterNote,
      }, { headers: { Authorization: `Bearer ${token}` } });
      setShowCounter(false);
      setCounterNote('');
      setCounterCash(0);
      alert('Counter offer sent!');
    } catch (err: any) { alert(err.response?.data?.error || 'Failed to send counter offer'); }
    setCounterLoading(false);
  };

  const handleAccept = async () => {
    if (!selectedOffer) return;
    setAccepting(true);
    try { await axios.post(`${API}/offers/${selectedOffer.id}/accept`,{},{headers}); setAccepted(true); fetchOffers(); window.dispatchEvent(new Event('refreshBadge')); setTimeout(()=>{setSelectedOffer(null);setAccepted(false);},2000); }
    catch(err){}
    setAccepting(false);
  };
  const filtered = offers.filter(o => {
    // show all active offers
    if (filterMetal!=='all'&&o.have_metal!==filterMetal) return false;
    if (search&&!o.have_product_name?.toLowerCase().includes(search.toLowerCase())&&!o.want_product_name?.toLowerCase().includes(search.toLowerCase())&&!o.company_name?.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });
  const getExpiry = (expires_at:string) => {
    if (!expires_at) return null;
    const diff = new Date(expires_at).getTime()-Date.now();
    const days = Math.floor(diff/(1000*60*60*24));
    if (days<0) return 'Expired'; if (days===0) return 'Today'; return `${days}d`;
  };
  return (
    <div className="flex gap-4 h-full">
      <div className="flex-1 min-w-0">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">{t('orderBook','Order Book')}</h1>
        <div className="flex gap-2 mb-4 flex-wrap">
          <input value={search} onChange={e=>setSearch(e.target.value)} className="border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none flex-1 min-w-32" placeholder={t('search','Search...')}/>
          {['all','Au','Ag','Pt','Pd'].map(m=><button key={m} onClick={()=>setFilterMetal(m)} className={`px-3 py-2 rounded-lg text-xs font-medium border ${filterMetal===m?'border-yellow-400 bg-yellow-50':'border-gray-200'}`}>{m==='all'?t('all','All'):m}</button>)}
        </div>
        <div className="space-y-2">
          {filtered.length===0&&<div className="bg-white border border-gray-200 rounded-xl p-8 text-center"><p className="text-gray-400 text-sm">No offers available</p></div>}
          {filtered.map(o=>(
            <div key={o.id} onClick={()=>setSelectedOffer(o)} className={`bg-white border rounded-xl p-4 cursor-pointer transition-all shadow-sm ${selectedOffer?.id===o.id?'border-yellow-400 bg-yellow-50':'border-gray-200 hover:border-gray-300'}`}>
              <div className="flex items-center justify-between">
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-1 mb-1">
                    {(o.have_items||[]).map((item:any,i:number)=>(
                      <span key={i} className="text-xs font-medium px-2 py-0.5 rounded" style={{backgroundColor:'#F5E6A3',color:'#B8860B'}}>{item.quantity}x {item.product_name}</span>
                    ))}
                  </div>
                  <div className="flex flex-wrap items-center gap-1">
                    <span className="text-xs text-gray-400">↔</span>
                    {(o.want_items||[]).map((item:any,i:number)=>(
                      <span key={i} className="text-xs text-gray-600">{item.quantity}x {item.product_name}{i<(o.want_items.length-1)?',':''}</span>
                    ))}
                  </div>
                  {o.cash_adjustment!==0&&<p className="text-xs mt-1" style={{color:'#B8860B'}}>{o.cash_adjustment>0?`+€${o.cash_adjustment} requested`:`-€${Math.abs(o.cash_adjustment)} offered`}</p>}
                </div>
                <div className="text-right ml-4 flex-shrink-0">
                  <p className="text-xs text-gray-500">{o.country}</p>
                  <p className="text-xs text-yellow-500 mt-1">{o.rating&&o.rating_count>0?`★ ${parseFloat(o.rating).toFixed(1)}`:'—'}</p>
                  {o.expires_at&&<p className="text-xs text-gray-300 mt-1">{getExpiry(o.expires_at)}</p>}
                </div>
              </div>
              {o.note&&<p className="text-xs text-gray-400 mt-2 truncate">{o.note}</p>}
            </div>
          ))}
        </div>
      </div>
      <div className="w-72 flex-shrink-0 hidden md:block">
        {selectedOffer?(
          <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm sticky top-4">
            <h3 className="font-bold text-gray-900 mb-4">Offer Details</h3>
            <div className="space-y-3 mb-6">
              <div><p className="text-xs text-gray-400">I Have</p>{(selectedOffer.have_items||[]).map((item:any,i:number)=><p key={i} className="text-sm font-medium text-gray-900">{item.quantity}x {item.product_name}</p>)}</div>
              <div><p className="text-xs text-gray-400">I Want</p>{(selectedOffer.want_items||[]).map((item:any,i:number)=><p key={i} className="text-sm font-medium text-gray-900">{item.quantity}x {item.product_name}</p>)}</div>
              {selectedOffer.cash_adjustment!==0&&<div><p className="text-xs text-gray-400">Cash Adjustment</p><p className="text-sm font-medium" style={{color:'#B8860B'}}>{selectedOffer.cash_adjustment>0?`+€${selectedOffer.cash_adjustment}`:`-€${Math.abs(selectedOffer.cash_adjustment)}`}</p></div>}
              <div><p className="text-xs text-gray-400">Country</p><p className="text-sm text-gray-900">{selectedOffer.country}</p></div>
              {selectedOffer.note&&<div><p className="text-xs text-gray-400">Note</p><p className="text-sm text-gray-600">{selectedOffer.note}</p></div>}
            </div>
            {accepted?<div className="text-center py-4"><p className="text-green-600 font-semibold">✓ Match created!</p></div>:
            Number(selectedOffer?.dealer_id)!==Number(dealer.id)?(
              <button onClick={handleAccept} disabled={accepting} className="w-full py-3 rounded-lg text-white font-semibold text-sm disabled:opacity-50" style={{backgroundColor:'#1a1a2e'}}>{accepting?'Accepting...':'Accept Offer'}</button>
            ):<p className="text-center text-xs text-gray-400 py-2">Your own offer</p>}
            {!showCounter && Number(selectedOffer?.dealer_id)!==Number(dealer.id) && (
              <button onClick={()=>setShowCounter(true)}
                className="w-full py-2 rounded-lg text-sm font-medium border border-gray-200 text-gray-600 hover:border-gray-400 mt-2">
                Counter Offer
              </button>
            )}
            {showCounter && (
              <div className="mt-3 border-t border-gray-100 pt-3">
                <p className="text-xs text-gray-500 mb-2 font-medium">Counter Offer</p>
                <div className="flex gap-2 mb-2">
                  <button onClick={()=>setCounterCashDir('request')}
                    className={"flex-1 py-1 rounded text-xs border " + (counterCashDir==='request'?'border-yellow-400 bg-yellow-50':'border-gray-200')}>
                    I Request
                  </button>
                  <button onClick={()=>setCounterCashDir('offer')}
                    className={"flex-1 py-1 rounded text-xs border " + (counterCashDir==='offer'?'border-yellow-400 bg-yellow-50':'border-gray-200')}>
                    I Offer
                  </button>
                </div>
                <input type="number" min={0} value={counterCash} onChange={e=>setCounterCash(parseFloat(e.target.value)||0)}
                  className="w-full border border-gray-200 rounded px-3 py-1.5 text-xs focus:outline-none mb-2"
                  placeholder="Cash adjustment (EUR)" />
                <input type="text" value={counterNote} onChange={e=>setCounterNote(e.target.value)}
                  className="w-full border border-gray-200 rounded px-3 py-1.5 text-xs focus:outline-none mb-2"
                  placeholder="Note (optional)" />
                <div className="flex gap-2">
                  <button onClick={handleCounter} disabled={counterLoading}
                    className="flex-1 py-2 rounded-lg text-white text-xs font-medium disabled:opacity-50"
                    style={{backgroundColor:'#B8860B'}}>
                    {counterLoading ? '...' : 'Send Counter'}
                  </button>
                  <button onClick={()=>setShowCounter(false)}
                    className="flex-1 py-2 rounded-lg text-xs border border-gray-200 text-gray-600">
                    Cancel
                  </button>
                </div>
              </div>
            )}
            <button onClick={()=>{setSelectedOffer(null);setShowCounter(false);}} className="w-full text-xs text-gray-400 hover:text-gray-600 mt-3 text-center">Cancel</button>
          </div>
        ):(
          <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm">
            <h3 className="font-semibold text-gray-900 mb-3">My Active Offers</h3>
            {myOffers.length===0?<p className="text-gray-400 text-xs">No active offers</p>:(
              <div className="space-y-2">{myOffers.map(o=><div key={o.id} className="text-xs text-gray-600 py-2 border-b border-gray-100 last:border-0"><p>{o.have_quantity}x {o.have_product_name}</p><p className="text-gray-400">↔ {o.want_quantity}x {o.want_product_name}</p></div>)}</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default OrderBook;
